import { Box, Tab } from "@mui/material";
import React, { useState } from "react";
import Base from "../../../Base/views/Base";
import AtsUserGrid from "./AtsUserGrid";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { GetATSModuleFeaturesAction } from "../../../../../store/RoleAccess/ATSModuleFeatures/Action";
import { useEffect } from "react";
import { getUserData } from "../../../Base/helper/baseFunctions";
import ATSUsersTargetGrid from "./ATSUserTargetGrid";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

const AtsUserLandingPage = () => {
  const user = getUserData();
  const isGroupOrgFlowTrue = user?.grouporg_flow === true;
  const dispatch = useDispatch();
  const location = useLocation();
  const [value, setValue] = useState("1");
  const { featuresData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleFeaturesReducer,
  );

  useEffect(() => {
    dispatch(GetATSModuleFeaturesAction({ module_name: "ATS Manage" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Base>
      <Box sx={{ borderRadius: "10px", overflowY: "auto" }}>
        <TabContext value={value}>
          <Box>
            <TabList
              sx={{
                minHeight: "40px",
                mb: 1,
                ".MuiTab-root": { minHeight: "20px" },
                "& .MuiTabs-indicator": {
                  width: "100%",
                  display: "flex",
                  justifyContent: "center !important",
                },
              }}
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              orientation="horizontal"
              allowScrollButtonsMobile={true}
            >
              <Tab label="Employee" value="1" />
              <Tab label="Non-Employee" value="2" />
              <Tab
                label={isGroupOrgFlowTrue ? "Group User" : "Client"}  value="3" />
              <Tab label="Hiring Partner" value="4" />
              
              <Tab label="Target" value="5" />
            </TabList>
          </Box>

          <TabPanel value="1" sx={{ padding: "0px" }}>
            <AtsUserGrid user_type={"Internal"} />
          </TabPanel>
          <TabPanel value="2" sx={{ padding: "0px" }}>
            <AtsUserGrid user_type={"ATS_Internal"} />
          </TabPanel>
          <TabPanel value="3" sx={{ padding: "0px" }}>
            <AtsUserGrid user_type={isGroupOrgFlowTrue ? "Group User" : "Company"} />
          </TabPanel>
          <TabPanel value="4" sx={{ padding: "0px" }}>
            <AtsUserGrid user_type={"Consultancy"} />
          </TabPanel>
          <TabPanel value="5" sx={{ padding: "0px" }}>
            <ATSUsersTargetGrid featuresData={featuresData} />
          </TabPanel>
        </TabContext>
      </Box>
    </Base>
  );
};

export default AtsUserLandingPage;
